import { render, staticRenderFns } from "./infoProdottoPreventivo.vue?vue&type=template&id=7f05a5ef&scoped=true&"
import script from "./infoProdottoPreventivo.vue.ts?vue&type=script&lang=ts&"
export * from "./infoProdottoPreventivo.vue.ts?vue&type=script&lang=ts&"
import style0 from "./infoProdottoPreventivo.vue?vue&type=style&index=0&id=7f05a5ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f05a5ef",
  null
  
)

export default component.exports